import { Navigate } from "react-router-dom"
import { useAuth } from "../../context/AuthContext"

export function AdminRoute({ children }) {
  const { user, userData } = useAuth()

  if (!user) return <Navigate to="/login" />
  if (!userData?.es_admin) return <Navigate to="/dashboard" />

  return children
}